module.exports = __webpack_public_path__ + "static/ML_SmartAgent@2x-66e4a05e4ce00a8eb4a0723ab4c5cc95.png";